// Third party libraries
import { CircleStencil, Cropper } from "vue-advanced-cropper";
import * as $ from "jquery";

export default {
    name: "FileUpload",
    components: {
        Cropper,
        CircleStencil,
    },
    props: {
        imageSource: {
            type: String,
            required: true,
        },
        fileBlob: {
            required: false,
        },
        isPetImage: {
            default: true,
        },
    },
    data() {
        return {
            image: this.imageSource,
        };
    },
    watch: {
        imageSource: {
            handler(newVal) {
                this.image = newVal;
            },
            immediate: true,
        },
    },
    methods: {
        show() {
            $(this.$refs.modalFileUpload).modal({
                backdrop: "static",
                keyboard: false,
            });
        },
        closeModal() {
            $(this.$refs.modalFileUpload).modal("hide");
        },
        crop() {
            // get the cropped image
            const { canvas } = this.$refs.cropper.getResult();

            if (canvas) {
                canvas.toBlob((blob) => {
                    // API doesnt accept blob so we need to convert it to file
                    const filename = this.fileBlob[0] ? this.fileBlob[0].name : "Pet-Image.jpg";
                    const lastModified = new Date();
                    const file = new File([blob], filename, { lastModified: lastModified });

                    const imageCrop = {
                        image: canvas.toDataURL(),
                        blob: [file],
                    };

                    // emit to parent
                    this.$emit("setImageCrop", imageCrop);
                }, "image/jpeg");

                this.closeModal();
            }
        },
    },
};
